export default __webpack_public_path__ + "static/media/atom.2f1244f1.svg";